export default function Legal({ kind }) {
  const isPrivacy = kind === "privacy";
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-14 lg:py-20">
      <p className="text-xs font-semibold uppercase tracking-[0.18em] text-indigo-600">Legal</p>
      <h1 className="mt-3 text-4xl font-extrabold text-slate-900 font-display">
        {isPrivacy ? "Privacy Policy" : "Terms & Conditions"}
      </h1>
      <div className="mt-8 space-y-6 text-slate-600 leading-relaxed">
        <p>
          {isPrivacy
            ? "We take your privacy seriously. Personal information you share via our enquiry form is used solely to match you with relevant career opportunities."
            : "By using CareerConnect, you agree to submit accurate information in enquiries and to communicate professionally with mentors and partner recruiters."}
        </p>
        <p>
          {isPrivacy
            ? "We never sell your data. Resumes are stored in encrypted cloud storage and are visible only to our internal recruitment team."
            : "You may withdraw an enquiry at any time by contacting our team. CareerConnect retains discretion to remove listings and accounts that violate our community guidelines."}
        </p>
        <p>Last updated: February 2026.</p>
      </div>
    </div>
  );
}
